var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-sheet',{class:['duration-item', _vm.classes]},[_c('v-list',{staticClass:"duration-item__list"},[_c('v-list-item-group',{attrs:{"value":_vm.lazyValue,"color":_vm.color,"mandatory":""},on:{"change":_vm.change}},_vm._l((_vm.computedOptions),function(ref){
var index = ref.index;
var value = ref.value;
var disabled = ref.disabled;
return _c('v-list-item',{key:index,attrs:{"value":value,"disabled":disabled}},[_c('v-list-item-content',[_c('v-list-item-title',{domProps:{"textContent":_vm._s(value)}})],1)],1)}),1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }